import styled from "styled-components";

export const ImageWrapper = styled.div<{ isVertical: boolean; isMobile: boolean }>`
  width: 100%;
  max-width: ${({ isVertical, isMobile }) =>
    isVertical ? (isMobile ? "80%" : "340px") : "100%"};

  img {
    width: 100%;
    height: auto;
    border-radius: 18px;
    display: block;
  }
`